import { MainComponent } from "../components";
import { connect } from "react-redux";
import {
    GetDataMainPlanTemplateAction, SetDataMainPlanTemplateAction,
    GetDataKHNamePlanTemplateAction, SetDataKHNamePlanTemplateAction,
    DeleteTemplatePlanType
} from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataMain: state.allPlanTemplateReducers.mainALLReducer.mainReducer.DataMain,
        DataKHName: state.allPlanTemplateReducers.mainALLReducer.KHNameReducer.DataKHName,
        DataDelete: state.allPlanTemplateReducers.mainALLReducer.DeleteReducer.DataDelete,
        isResult: state.allPlanTemplateReducers.isResultReducer.isResult
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataMain: (DataMain) => {
            dispatch(GetDataMainPlanTemplateAction(DataMain));
        },
        SetDataMain: (DataMain) => {
            dispatch(SetDataMainPlanTemplateAction(DataMain));
        },
        GetDataKHName: (DataKHName) => {
            dispatch(GetDataKHNamePlanTemplateAction(DataKHName));
        },
        SetDataKHName: (DataKHName) => {
            dispatch(SetDataKHNamePlanTemplateAction(DataKHName));
        },
        // DeleteTemplate: (DataDelete) => {
        //     dispatch(GetDeleteTemplateSuccessAction(DataDelete));
        // }

        DeleteTemplate: (DataDelete) => {
            dispatch(DeleteTemplatePlanType(DataDelete));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);